import React from "react";
import { BiStar } from "react-icons/bi";
import "../styles/Pages.css";

const ForYouPage = ({ user }) => {
  const recommendations = [
    {
      title: "Upgrade to Premium Card",
      description: "Get exclusive perks and higher rewards",
      action: "Learn More",
    },
    {
      title: "Start Saving for Retirement",
      description: "Build your future with our retirement plans",
      action: "View Plans",
    },
    {
      title: "Protect Your Family",
      description: "Get life insurance starting from R250/month",
      action: "Get Quote",
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>For You</h1>
        <p className="page-subtitle">Personalized offers and recommendations</p>
      </div>

      <div className="recommendations-section">
        <h3>Recommended for You</h3>
        <div className="recommendations-list">
          {recommendations.map((rec, idx) => (
            <div key={idx} className="recommendation-card">
              <BiStar className="recommendation-icon" />
              <div className="recommendation-content">
                <h4>{rec.title}</h4>
                <p>{rec.description}</p>
              </div>
              <button className="btn-outline">{rec.action}</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ForYouPage;
